import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
//atoms
import { useRecoilValue } from 'recoil';
import dateJoinedAtom from "recoil/account/dateJoined";
//utils
import moment from 'moment';
import { generateEarningsYearOptions } from "utils/optionsProvider";
import { currencyFormatter, numberFormatter } from 'utils/formatter';
//hooks
import useEarnings from 'hooks/useEarnings';
//fonts
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';

const InsightCampaigns = () => {
    const campaignSelectionRef = useRef(null);
    const datePickRef = useRef(null);
    const curYear = moment().year();
    const yearOptions = generateEarningsYearOptions(useRecoilValue(dateJoinedAtom));
    const { dateRangeID } = useCampaigns();
    const { data: campaignList } = useCampaignsSummary(dateRangeID);

    const [campaignSelectionOn, setCampaignSelectionOn] = useState(false);
    const [campaignSelectionValue, setCampaignSelectionValue] = useState(0);
    const [selectedYear, setSelectedYear] = useState(curYear);
    const [dateSelDropdownOn, setDateSelDropdownOn] = useState(false);

    const [hoveredId, setHoveredId] = useState(null);

     const [isClicked, setIsClicked] = useState(false);
        
        const handleHoveredClicked = (id)=>{
            
            setHoveredId(prev=>{
                if(prev != id) {
                    return id;
                }
                return null;
            });
            setIsClicked(prev=>!prev);
        }

    const { data: earnings } = useEarnings(campaignSelectionValue, selectedYear);

    const updateSelYear = (year, e) => {
        e.preventDefault();
        setSelectedYear(year);
        setDateSelDropdownOn(false);
    }


    const handleCampaignSelection = (value) => {
        setCampaignSelectionValue(value);
        setCampaignSelectionOn(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (campaignSelectionRef.current && !campaignSelectionRef.current.contains(event.target))
                setCampaignSelectionOn(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (datePickRef.current && !datePickRef.current.contains(event.target))
                setDateSelDropdownOn(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
            function handleClickOutside(e) {
                if (hoveredId) {
                    setHoveredId(null);
                    setIsClicked(false);
                }
            }
    
            document.addEventListener("mousedown", handleClickOutside);
            return () => document.removeEventListener("mousedown", handleClickOutside);
        }, [hoveredId]);

    return (
        <div className={classNames('card', 'campaign')}>
            <div className='card-header'>
                <div ref={campaignSelectionRef} className={classNames('campaign-selection-list', 'selection-list', { on: campaignSelectionOn })}>
                    <select
                        className='table-select'
                        value={campaignSelectionValue}
                        onChange={(e)=>{e.preventDefault(); setCampaignSelectionValue(e.target.value)}}
                        >
                        <option value="-1">All campaigns</option>
                        {
                            campaignList?.StatsSummaries
                            && [...campaignList.StatsSummaries]
                                .map(c => ({
                                    ...c,
                                    CampaignDetail: {
                                        ...c.CampaignDetail,
                                        Title: c.CampaignDetail.Title || 'Campaign',
                                    }
                                }))
                                .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                                .map((item, i) => (
                                    <option 
                                        key={`campaignItm_${i}`}
                                        value={item.CampaignDetail.CampaignID}
                                        >{item.CampaignDetail.Title}</option>
                                ))
                        }
                    </select>
                    
                    {/* <p className='selection-value' onClick={() => setCampaignSelectionOn(!campaignSelectionOn)}>
                        <span className='campaign-title'>
                            {
                                campaignSelectionValue < 1
                                    ? 'All campaigns'
                                    : campaignList?.StatsSummaries?.find(itm => itm.CampaignDetail.CampaignID === campaignSelectionValue)
                                        ?.CampaignDetail.Title ?? 'All campaigns'
                            }
                        </span>
                        {campaignSelectionOn
                            ? <FontAwesomeIcon className='arrow-up-ico' icon={faChevronUp} />
                            : <FontAwesomeIcon className='arrow-down-ico' icon={faChevronDown} />}
                    </p>



                    <ul className='selection-option-list'>
                        <li>
                            <a
                                className={classNames('selection-item', { 'on': campaignSelectionValue < 1 })}
                                onClick={() => handleCampaignSelection(0)}
                            >All campaigns</a>
                        </li>
                        {
                            campaignList?.StatsSummaries
                            && [...campaignList.StatsSummaries]
                                .map(c => ({
                                    ...c,
                                    CampaignDetail: {
                                        ...c.CampaignDetail,
                                        Title: c.CampaignDetail.Title || 'Campaign',
                                    }
                                }))
                                .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                                .map((item, i) => (
                                    <li key={i}>
                                        <a
                                            className={classNames('selection-item', { 'on': item.CampaignDetail.CampaignID === campaignSelectionValue })}
                                            onClick={() => handleCampaignSelection(item.CampaignDetail.CampaignID)}
                                        >{item.CampaignDetail.Title}</a>
                                    </li>
                                ))
                        }
                    </ul> */}
                </div>

                <div className="date-select">
                    <p className="selected-date" onClick={(e) => { setDateSelDropdownOn(!dateSelDropdownOn); e.stopPropagation() }}>{selectedYear} <FontAwesomeIcon icon={faChevronDown} /></p>
                    <div ref={datePickRef} className={classNames("date-pick", { "on": dateSelDropdownOn })}>
                        <ul>
                            {
                                yearOptions.map((year, i) => <li key={`dt_${i}`}><a href="/" title="Today" onClick={(e) => { updateSelYear(year, e) }}>{year}</a></li>)
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className='card-content'>
                <table className="compaign-table total-earning">
                    <thead className={classNames("thead")}>
                        <tr>
                            <th>Date</th>
                            <th>Joins</th>
                            <th>Sales</th>
                            <th>Earnings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            earnings &&
                            <>
                                {
                                    earnings.length > 0
                                        ? [...earnings]
                                            .sort((a, b) => a.Date > b.Date ? 1 : -1)
                                            .map((campaign, i) => {
                                                const rowid=`campaign_${selectedYear}_browser_${i}`;
                                                return (
                                                <tr key={rowid}>
                                                    <td><span className='campaign-date'>{moment(campaign.Date).format("MMM YYYY")}</span></td>
                                                    <td>{campaign.Joins > 0 ? numberFormatter.format(campaign.Joins) : '-'}</td>
                                                    <td>{campaign.Upgrades > 0 ? numberFormatter.format(campaign.Upgrades) : '-'} {campaign.Upgrades > 0 && campaign.Joins > 0 ? `(${Math.round(campaign.Upgrades * 100 / campaign.Joins)}%)` : ``}</td>
                                                    <td className='tooltip'>
                                                        <span translate="no" className="notranslate" 
                                                            onClick={()=>{  if(campaign.Revenue > 0){ handleHoveredClicked(rowid)}}}
                                                            onMouseEnter={() => {campaign.Revenue > 0 && setHoveredId(rowid)}}
                                                            onMouseLeave={() => { campaign.Revenue > 0 && !isClicked && setHoveredId(null)}}>
                                                                {campaign.Revenue > 0 ? currencyFormatter.format(campaign.Revenue) : '-'}
                                                        </span>
                                                        {   hoveredId == rowid 
                                                            && 
                                                            <em className='tooltip-bubble'>
                                                                <span className="title">Earnings breakdown</span>
                                                                <span>Revenue Share: <span translate="no"  className='notranslate'>{currencyFormatter.format(campaign.Revenue - (campaign.RevenueQL ?? 0))}</span></span>
                                                                <span className='ql'><span>Qualified Leads:</span><span translate="no"  className={classNames("notranslate", {"dash":!campaign.RevenueQL || campaign.RevenueQL < 1})}>{ (campaign.RevenueQL && campaign.RevenueQL > 0) ? currencyFormatter.format(campaign.RevenueQL) : '-'}</span></span>
                                                            </em>
                                                        }
                                                    </td>
                                                </tr>
                                            )})
                                        : <tr><td className='empty' colSpan={4}>No results found</td></tr>
                                }
                            </>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default InsightCampaigns;